// =============================================================================
// KI-API – Frontend-Service
// -----------------------------------------------------------------------------
// Stammdaten (Anbieter, Bereiche, Modelle, Modell-Parameter) und
// KI-API-Konfigurationen. Alle Endpunkte sind nur fuer Administratoren.
// =============================================================================

import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

// entity: "providers" | "categories" | "models" | "model-params"
const listMasterData = (entity) => axios.get(`${API_URL}ai-masterdata/${entity}`, { headers: authHeader() });
const createMasterData = (entity, data) => axios.post(`${API_URL}ai-masterdata/${entity}`, data, { headers: authHeader() });
const updateMasterData = (entity, id, data) => axios.put(`${API_URL}ai-masterdata/${entity}/${id}`, data, { headers: authHeader() });
const deleteMasterData = (entity, id) => axios.delete(`${API_URL}ai-masterdata/${entity}/${id}`, { headers: authHeader() });

const listConfigs = () => axios.get(`${API_URL}ai-configs`, { headers: authHeader() });
const createConfig = (data) => axios.post(`${API_URL}ai-configs`, data, { headers: authHeader() });
const updateConfig = (id, data) => axios.put(`${API_URL}ai-configs/${id}`, data, { headers: authHeader() });
const deleteConfig = (id) => axios.delete(`${API_URL}ai-configs/${id}`, { headers: authHeader() });
const testConfig = (id, data) => axios.post(`${API_URL}ai-configs/${id}/test`, data, { headers: authHeader(), timeout: 180000 });

const AiApiService = {
  listMasterData,
  createMasterData,
  updateMasterData,
  deleteMasterData,
  listConfigs,
  createConfig,
  updateConfig,
  deleteConfig,
  testConfig,
};

export default AiApiService;
